var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-social",class:[_vm.hover === 'conahcyt' ? 'conahcyt': 'gob', _vm.icono],attrs:{"href":_vm.url,"target":"_blank","rel":"noopener"}},[_c('span',{staticClass:"a11y-solo-lectura"},[_vm._v(_vm._s(_vm.spanglish))])])
}
var staticRenderFns = []

export { render, staticRenderFns }